CCL.imageGallery = {
  autoload: [
    ['imageGallery', $('.c-image-gallery').length > 0],
    ['getAriaLabel', $('.image-gallery-wrap').length > 0]
  ],

  totalImagesCount: '',
  cuurentSlideCount: '',
  clickCount: 0,
  prevStart: 0,
  tabStarting: 1,
  currentSlideNo: 0,
  firstPrevClicked: false,

  getAriaLabel() {
    setTimeout(() => {
      const listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      if (listArray.length) {
        for (let i = 0; i < listArray.length; i++) {
          const imageName = listArray[i].querySelector('a img').getAttribute('alt');
          const current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr('aria-label', `${imageName} of ${listArray.length} ${current}`);
        }
      }
    }, 300);
  },

  imageGallery() {
    const slider = $('#c-image-gallery').lightSlider({
      gallery: true,
      item: 1,
      hybrid: true,
      // loop: true,
      hybridWidth: 656,
      vThumbWidth: 80,
      thumbItem: 9,
      thumbMargin: 8,
      slideMargin: 0,
      onBeforeStart($el) {
        const srcImg = $el.find('li img').first().attr('data-src');
        const $img = $el.find('li img').first();
        $img.attr('src', srcImg);
        $img.css('display', 'initial');
      },
      onAfterSlide($el, scene) {
        const $img = $el.find('img').eq($el.getCurrentSlideCount() - 1);
        const $imgSrc = $img.attr('data-src');
        $img.attr('src', $imgSrc);
        $img.css('display', 'initial');
        if ($el.getCurrentSlideCount() === 1) {
          $('.lSPrev').hide();
        } else if (Number($el.getCurrentSlideCount()) === Number($el.find('li').length)) {
          $('.lSNext').hide();
        } else {
          $('.lSPrev').show();
          $('.lSNext').show();
        }

        this.totalImagesCount = slider.getTotalSlideCount();
        this.cuurentSlideCount = slider.getCurrentSlideCount();
        if (this.cuurentSlideCount > 1 && this.totalImagesCount > 7) { // if max image count increases display up arrow
          $('#goToPrevSlide').css('display', 'block');
        } else {
          $('#goToPrevSlide').css('display', 'none');
        }
      },
      onSliderLoad($el) {
        $('.lSPrev').hide();
        $('#c-image-gallery').removeClass('cS-hidden');

        $('.lSPager.lSGallery li a').on('click', (e) => {
          setTimeout(() => {
            if (document.querySelector('.image-gallery-wrap')) {
              const listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
              if (listArray.length) {
                for (let i = 0; i < listArray.length; i++) {
                  const imageName = listArray[i].querySelector('a img').getAttribute('alt');
                  const current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
                  $(listArray[i].querySelector('a')).attr('aria-label', `${imageName} of ${listArray.length} ${current}`);
                }
              }
            }
          }, 300);
        });
      }
    });

    this.totalImagesCount = slider.getTotalSlideCount();
    if (this.totalImagesCount > 7) { // if max image count increases display down arrow
      $('#goToNextSlide').css('display', 'block');
    } else {
      $('#goToNextSlide').css('display', 'none');
    }

    $('#goToNextSlide').on('focus', (e) => {
      const getCurrentImageCount = slider.getCurrentSlideCount();
      this.totalSlides = slider.getTotalSlideCount();
      const itemlist = $('.lSPager.lSGallery li a img');
      this.getAriaLabel();
      if (getCurrentImageCount + 1 === this.totalSlides) {
        const item = itemlist[0].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide 1 of ${this.totalSlides}`);
      } else if (getCurrentImageCount === this.totalSlides) {
        const item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide 2 of ${this.totalSlides}`);
      } else if (getCurrentImageCount + 1 < this.totalSlides) {
        const item = itemlist[getCurrentImageCount + 1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide  ${getCurrentImageCount + 2} of ${this.totalSlides}`);
      }
    });

    $('#goToNextSlide').on('click keypress', (e) => {
      const getCurrentImageCount = slider.getCurrentSlideCount();
      this.totalSlides = slider.getTotalSlideCount();
      const itemlist = $('.lSPager.lSGallery li a img');
      this.getAriaLabel();
      if (getCurrentImageCount + 1 === this.totalSlides) {
        const item = itemlist[0].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide 1 of ${this.totalSlides}`);
      } else if (getCurrentImageCount === this.totalSlides) {
        const item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide 2 of ${this.totalSlides}`);
      } else if (getCurrentImageCount + 1 < this.totalSlides) {
        const item = itemlist[getCurrentImageCount + 1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Next Slide ${getCurrentImageCount + 2} of ${this.totalSlides}`);
      }
      if (getCurrentImageCount === this.totalImagesCount) {
        slider.goToSlide(0);
        this.clickCount = 0;
        this.tabStarting = 1;
        const visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
        for (let i = 0; i < visibleItems.length; i++) {
          visibleItems[i].querySelector('a').tabIndex = -1;
          visibleItems[i].classList.add('hiddenn');
        }
        for (let j = 0; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
          visibleItems[j].querySelector('a').tabIndex = 0;
          visibleItems[j].classList.remove('hiddenn');
        }
      } else {
        this.clickCount++;
        slider.goToNextSlide();
      }
      if (this.clickCount >= 5) {
        const visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
        if (((Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1) + this.tabStarting) <= (visibleItems.length - 1)) {
          for (let i = 0; i < visibleItems.length; i++) {
            visibleItems[i].querySelector('a').tabIndex = -1;
            visibleItems[i].classList.add('hiddenn');
          }

          if ((((Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1) + this.tabStarting) === (visibleItems.length - 1)) && (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) === 7)) {
            for (let j = 0; j < (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1); j++) {
              visibleItems[j + this.tabStarting].querySelector('a').tabIndex = 0;
              visibleItems[j + this.tabStarting].classList.remove('hiddenn');
            }
          } else {
            for (let j = 1; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
              visibleItems[j + this.tabStarting].querySelector('a').tabIndex = 0;
              visibleItems[j + this.tabStarting].classList.remove('hiddenn');
            }
          }
          this.tabStarting++;
        }
      }
    });

    $('#goToPrevSlide').on('focus', (e) => {
      const getCurrentImageCount = slider.getCurrentSlideCount();
      this.totalSlides = slider.getTotalSlideCount();
      const itemlist = $('.lSPager.lSGallery li a img');
      this.getAriaLabel();
      if (getCurrentImageCount === 1) {
        $(e.currentTarget).attr('aria-label', '');
      } else if (getCurrentImageCount === this.totalSlides) {
        const item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Previous Slide 2 of ${this.totalSlides}`);
      } else if (getCurrentImageCount - 1 < this.totalSlides) {
        const item = itemlist[getCurrentImageCount - 2].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Previous Slide ${getCurrentImageCount - 1} of ${this.totalSlides}`);
      }
    });

    $('#goToPrevSlide').on('click keypress', (e) => {
      slider.goToPrevSlide();
      this.totalSlides = slider.getTotalSlideCount();
      const itemlist = $('.lSPager.lSGallery li a img');
      this.getAriaLabel();
      if (this.tabStarting !== 1) {
        this.tabStarting--;
      }
      if (this.clickCount !== 0) {
        this.clickCount--;
      }
      const visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
      for (let i = 0; i < visibleItems.length; i++) {
        if (visibleItems[i] === e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelector('li.active')) {
          this.prevStart = i;
        }
        if (visibleItems[i] === e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelector('li:not(.hiddenn)')) {
          this.currentSlideNo = i;
        }
      }

      const getCurrentImageCount = slider.getCurrentSlideCount();
      this.totalSlides = slider.getTotalSlideCount();
      if (getCurrentImageCount === 1) {
        $(e.currentTarget).attr('aria-label', '');
      } else if (getCurrentImageCount === this.totalSlides) {
        const item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Previous Slide 2 of ${this.totalSlides}`);
      } else if (getCurrentImageCount - 1 < this.totalSlides) {
        const item = itemlist[getCurrentImageCount - 2].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', `Go To ${item}. Previous Slide ${getCurrentImageCount - 1} of ${this.totalSlides}`);
      }
      // if (this.firstPrevClicked) {
      //   if (this.currentSlideNo === 1) {
      //     this.firstPrevClicked = false;
      //   }
      //   for (let i = 0; i < visibleItems.length; i++) {
      //     visibleItems[i].querySelector('a').tabIndex = -1;
      //     visibleItems[i].classList.add('hiddenn');
      //   }
      //   for (let j = (this.currentSlideNo - 1); j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
      //     visibleItems[j].querySelector('a').tabIndex = 0;
      //     visibleItems[j].classList.remove('hiddenn');
      //   }
      // }
      if (this.prevStart > 3 && this.prevStart < 7) {
        // this.firstPrevClicked = true;
        for (let i = 0; i < visibleItems.length; i++) {
          visibleItems[i].querySelector('a').tabIndex = -1;
          visibleItems[i].classList.add('hiddenn');
        }
        if (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) === 7 && this.prevStart !== 4) {
          for (let j = 0; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
            visibleItems[(this.currentSlideNo - 2) + j].querySelector('a').tabIndex = 0;
            visibleItems[(this.currentSlideNo - 2) + j].classList.remove('hiddenn');
          }
        } else {
          for (let j = 0; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
            visibleItems[(this.currentSlideNo - 1) + j].querySelector('a').tabIndex = 0;
            visibleItems[(this.currentSlideNo - 1) + j].classList.remove('hiddenn');
          }
        }
      }
    });
  }
};

/* eslint-disable */

;
(function ($, window, document) {
  var vListFlag = true;
  $(document.body).on('click', (e) => {
    if (vListFlag && document.querySelector('.image-gallery-wrap')) {
      var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      if (listArray.length) {
        var arrayEnd = Math.floor(document.querySelectorAll('.lSSlideOuter')[0].offsetHeight / 54);
        for (var i = arrayEnd; i < listArray.length; i++) {
          listArray[i].querySelector('a').tabIndex = -1;
          listArray[i].classList.add("hiddenn");
        }
        // var pathname = window.location.pathname.split('/')
        for (var i = 0; i < listArray.length; i++) {
          var imageName = listArray[i].querySelector('a img').getAttribute('alt');
          var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr({ href: 'javascript:;', role: 'button' });
          $(listArray[i].querySelector('a')).attr('aria-label', `${imageName} of ${listArray.length} ${current}`);
        }
        vListFlag = false;
      }
    }
  });
  $(document.body).on('keyup', (e) => {

    if (vListFlag && document.querySelector('.image-gallery-wrap')) {
      var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      var arrayEnd = Math.floor(document.querySelectorAll('.lSSlideOuter')[0].offsetHeight / 54);
      for (var i = arrayEnd; i < listArray.length; i++) {
        listArray[i].querySelector('a').tabIndex = -1;
        listArray[i].classList.add("hiddenn");
      }
      // var pathname = window.location.pathname.split('/')
      if (listArray.length > 0) {
        for (var i = 0; i < listArray.length; i++) {
          var imageName = listArray[i].querySelector('a img').getAttribute('alt');
          var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr({ href: 'javascript:;', role: 'button' });
          $(listArray[i].querySelector('a')).attr('aria-label', `${imageName} of ${listArray.length} ${current}`);
        }
      }

      vListFlag = false;
    }
  });
})(window.Zepto || window.jQuery, window, document);


// WEBPACK FOOTER //
// ./src/app/components/c-image-gallery/image-gallery.js